const breakpointsMapping = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
} as const;

const breakpointsInPixels = {
  [breakpointsMapping.xs]: 400,
  [breakpointsMapping.sm]: 600,
  [breakpointsMapping.md]: 800,
  [breakpointsMapping.lg]: 1100,
} as const;

export const breakpoints = {
  [breakpointsMapping.xs]: `${breakpointsInPixels.xs}px`,
  [breakpointsMapping.sm]: `${breakpointsInPixels.sm}px`,
  [breakpointsMapping.md]: `${breakpointsInPixels.md}px`,
  [breakpointsMapping.lg]: `${breakpointsInPixels.lg}px`,
} as const;
